import { AppThunkAction } from ".";
import { Authorization } from "./Interfaces";

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
  requestauthorizations: (
    authtype: string,
    myCallback: () => void
  ): AppThunkAction<KnownAction> => (dispatch, getState) => {
    // Only load data if it's something we don't already have (and are not already loading)
    const appState = getState();
    if (
      appState &&
      appState.authorizationstate
    ) {
      fetch(process.env.REACT_APP_API_HOST + `/CABSBill/` + authtype, {
        method: "GET",
        credentials: "include",
        headers: {
          pragma: "no-cache",
          "cache-control": "no-cache",
        },
      })
        .then((response) => response.json() as Promise<Authorization>)
        .then((data) => {
          dispatch({
            type: "RECEIVE_AUTHORIZATIONS",
            payload: { authorizations: data },
            authtype,
            isError: false,
          });
          myCallback();
        })
        .catch((error) => {
          const currentAuthorizations = appState.authorizationstate.authorizations;
          dispatch({
            type: "RECEIVE_AUTHORIZATIONS",
            payload: {
              authorizations: currentAuthorizations
                ? currentAuthorizations
                : {
                  internalrole: "",
                  adminrole: false,
                  adminuserrole: false,
                  ctsuserrole: false,
                  cssuserrole: false,
                  cwpretailrole: false,
                },
            },
            authtype:authtype,
            isError: true,
          });
        });

      dispatch({ type: "REQUEST_AUTHORIZATIONS" });
    }
  },
};

export const RECEIVE_AUTHORIZATIONS = "RECEIVE_AUTHORIZATIONS";
export const REQUEST_AUTHORIZATIONS = "REQUEST_AUTHORIZATIONS";

interface RECEIVE_AUTHORIZATIONS {
  type: "RECEIVE_AUTHORIZATIONS";
  payload: {
    authorizations: Authorization;
  };
  authtype: string;
  isError: boolean;
}
interface REQUEST_AUTHORIZATIONS {
  type: "REQUEST_AUTHORIZATIONS";
}

export type KnownAction =
  | RECEIVE_AUTHORIZATIONS
  | REQUEST_AUTHORIZATIONS;
